import Auth from '@aws-amplify/auth';
import { CognitoUserSession } from 'amazon-cognito-identity-js';
let session: CognitoUserSession;

export const getJwtToken = async (): Promise<string | void> => {
	try {
		if (!session || !session.isValid()) {
			session = await Auth.currentSession();
		}
		return session.getIdToken().getJwtToken();
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Getting token failed', err);
	}
};

export const getJwtAccessToken = async (): Promise<string | void> => {
	try {
		if (!session || !session.isValid()) {
			session = await Auth.currentSession();
		}
		return session.getAccessToken().getJwtToken();
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Getting access token failed', err);
	}
};

export const getCurrentUserEmail = async (): Promise<string> => {
	try {
		const user = await Auth.currentAuthenticatedUser();
		return user?.attributes?.email ?? user?.username ?? 'unknown';
	} catch (err) {
		// eslint-disable-next-line no-console
		console.error('Getting current user failed', err);
		return 'unknown';
	}
};
